export { ProductName } from "@hooks/useMemberUser";
export { MemberProductLevelEnum } from "@/src/features/api/memberApi";
import { MemberProductLevelEnum } from "@/src/features/api/memberApi";

export const RewardKey = {
  Once: "AURA_REWARD_ONCE",
  Daily: "AURA_REWARD_DAILY",
};

// type: FREE, TRIAL, NORMAL, REWARD
export enum ProductType {
  FREE = "FREE",
  TRIAL = "TRIAL",
  NORMAL = "NORMAL",
  REWARD = "REWARD", // 折扣产品
}

export const ProductLevelType = {
  [MemberProductLevelEnum.EXPERT]: "Expert",
  [MemberProductLevelEnum.PRO]: "Pro",
  [MemberProductLevelEnum.FREE]: "Free",
} as const;

export enum ProductPayCycle {
  MONTH = "MONTH",
  YEAR = "YEAR",
  WEEK = "WEEK",
  LIFETIME = "LIFETIME",
}

export enum ProductStatus {
  EXPIRED = "EXPIRED",
  ACTIVE = "ACTIVE",
}

export enum ProductPlanStatus {
  HIDDEN = "HIDDEN",
  ACTIVE = "ACTIVE",
}
